import React, { useEffect } from 'react';
// import TagManager from 'react-gtm-module';
import Designers from '../components/Designerss';
import HomeHero from '../components/HomeHero'
import SliderContainer from '../components/SliderContainer';

const Home = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <HomeHero />
      <Designers titleVisible={false} />
      <SliderContainer />
    </>
  )
};

// TagManager.dataLayer({
//   dataLayer: {
//       event: 'event_SiteDisplayed'
//   }
// });

export default Home